var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { UiService } from '../ui/ui.service';
import Elpong from 'elpong';
import { ZevensterStateService } from '../zevenster-state/zevenster-state.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
var ZevensterPageComponent = /** @class */ (function () {
    function ZevensterPageComponent(ui, zevensterStateService, router) {
        var _this = this;
        this.ui = ui;
        this.zevensterStateService = zevensterStateService;
        this.router = router;
        this.clickedSquareIds = new Set();
        this.selectedSquareIds = new Set();
        this.clickedSquare$ = new Subject();
        this.hasSetAreaInNumbers = false;
        this.wantedArea = 0;
        this.previousWantedArea = 0;
        this.wantedPrice = 0;
        this.previousWantedPrice = 0;
        this.ceiledWantedPrice = 0;
        this.selectedArea = 0;
        this.areaToBeSelected = 0;
        this.areaToBeSelectedSmall = 0;
        this.areaToBeSelectedLarge = 0;
        this.scheme = Elpong.get('greenplease');
        this.clickedSquareFocused$ = this.clickedSquare$.pipe(filter(function (sqId) { return !_this.clickedSquareIds.has(sqId); }));
        this.clickedSquareUnfocused$ = this.clickedSquare$.pipe(filter(function (sqId) { return _this.clickedSquareIds.has(sqId); }));
    }
    ZevensterPageComponent.prototype.onAreaInputChange = function (area) {
        if (area > 9 && (area % 9 !== 0)) {
            if (area > this.previousWantedArea) {
                this.wantedArea = Math.ceil(area / 9) * 9;
            }
            else {
                this.wantedArea = Math.floor(area / 9) * 9;
            }
        }
        else {
            this.wantedArea = area;
        }
        this.previousWantedArea = this.wantedArea;
        if (this.wantedArea)
            this.hasSetAreaInNumbers = true; // if not 0
        this.recalculateAreaToBeSelected();
        this.recalculatePrice();
    };
    ZevensterPageComponent.prototype.onPriceInputChange = function (price) {
        this.wantedPrice = price;
        this.ceiledWantedPrice = Math.ceil(this.wantedPrice);
        this.wantedArea = Math.floor(price * 9 / 40);
        this.onAreaInputChange(this.wantedArea);
    };
    ZevensterPageComponent.prototype.ngOnInit = function () {
    };
    ZevensterPageComponent.prototype.ngAfterViewInit = function () {
        this.ui.whitened$.next(true);
    };
    ZevensterPageComponent.prototype.ngOnDestroy = function () {
        this.ui.whitened$.next(false);
    };
    ZevensterPageComponent.prototype.clickSquare = function (squareId) {
        this.clickedSquare$.next(squareId);
        if (this.clickedSquareIds.has(squareId)) {
            this.clickedSquareIds.delete(squareId);
        }
        else {
            this.clickedSquareIds.add(squareId);
        }
    };
    ZevensterPageComponent.prototype.selectSquare = function (squareId) {
        if (this.selectedSquareIds.has(squareId)) {
            this.selectedSquareIds.delete(squareId);
        }
        else {
            this.selectedSquareIds.add(squareId);
        }
        this.selectedArea = this.selectedSquareIds.size;
        if (!this.hasSetAreaInNumbers) {
            this.wantedArea = this.selectedArea;
            this.recalculateAreaToBeSelected();
        }
        else {
            this.recalculateAreaToBeSelected();
            if (this.areaToBeSelected === 0)
                this.hasSetAreaInNumbers = false;
        }
        this.recalculatePrice();
    };
    ZevensterPageComponent.prototype.formatId = function (squareId) {
        return ('00000' + squareId).slice(-5);
    };
    ZevensterPageComponent.prototype.getTotalPrice = function () {
        return Math.ceil(this.wantedArea * 40 / 9);
    };
    ZevensterPageComponent.prototype.recalculatePrice = function () {
        this.wantedPrice = this.getTotalPrice();
        this.ceiledWantedPrice = Math.ceil(this.getTotalPrice());
    };
    ZevensterPageComponent.prototype.recalculateAreaToBeSelected = function () {
        this.areaToBeSelected = this.wantedArea - this.selectedArea;
        this.areaToBeSelectedLarge = Math.abs(Math.floor(this.areaToBeSelected / 9));
        this.areaToBeSelectedSmall = Math.abs(this.areaToBeSelected - this.areaToBeSelectedLarge * 9);
    };
    ZevensterPageComponent.prototype.clickCheckout = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var purchases, purchase, fields;
            return __generator(this, function (_a) {
                if (this.areaToBeSelected !== 0)
                    return [2 /*return*/];
                purchases = this.scheme.select('zevenster_purchases');
                purchase = purchases.build({ total_area: this.wantedArea });
                fields = purchase.fields;
                fields.areas = Array.from(this.selectedSquareIds);
                fields.paid = false;
                this.zevensterStateService.purchase = purchase;
                this.router.navigateByUrl('/zevensterbos/checkout');
                return [2 /*return*/];
            });
        });
    };
    ZevensterPageComponent.prototype.keypress = function ($event) {
        // if ($event.keyCode == 13) {
        //   event.preventDefault();
        // }
    };
    ZevensterPageComponent.prototype.clickAreaPlus = function () {
        this.onAreaInputChange(this.wantedArea + 1);
    };
    ZevensterPageComponent.prototype.clickAreaMinus = function () {
        if (this.wantedArea <= 0)
            return;
        this.onAreaInputChange(this.wantedArea - 1);
    };
    ZevensterPageComponent.prototype.clickPricePlus = function () {
        this.onPriceInputChange(this.wantedPrice + 40 / 9);
    };
    ZevensterPageComponent.prototype.clickPriceMinus = function () {
        if (this.wantedPrice <= 0)
            return;
        this.onPriceInputChange(this.wantedPrice - 40 / 9);
    };
    return ZevensterPageComponent;
}());
export { ZevensterPageComponent };
//# sourceMappingURL=zevenster-page.component.js.map